import { createFileRoute } from "@tanstack/react-router"
import WeightPlateCalculator from "../components/weightPlateCalculator/index"

export const Route = createFileRoute("/_app/plate-calculator")({
  component: WeightPlateCalculator,
})
